import React, { PureComponent } from "react";
import { Select, Tabs } from "antd";
import { DESIGN_FAILED } from '@/constants/designCategory';
import { PCB_CHANNEL, EXPERIMENTS } from "@/constants/treeConstants";
import '@/publicCss/style.css';
import '@/publicCss/debug.css';
import { ANDES_V2 } from "../../constants/pageType";
import { PACKAGE } from "../../constants/designType";
import { PCB_PARSING, REPORT, NETWORK_PARAMETER } from "../../services/helper/debugHelper";

function getOptions(options, product, menuType) {
  let optioGroup = [];
  if (product === ANDES_V2 && [PCB_PARSING, PCB_CHANNEL, REPORT].includes(menuType)) {
    let pcbList = [], packageList = [];
    for (const option of options) {
      if (option.type === PACKAGE) {
        packageList.push(option);
      } else {
        pcbList.push(option);
      }
    }
    optioGroup = [{ type: 'PCB', children: pcbList }, { type: 'PKG', children: packageList }]
  }

  return product === ANDES_V2 && [PCB_PARSING, PCB_CHANNEL, REPORT].includes(menuType)
    ? optioGroup.map(item => ({
      label: item.type,
      options: item.children.map(it => ({
        label: it.name,
        title: it.name,
        value: it.id,
      }))
    }))
    : options.map(item => ({
      label: item.name,
      title: item.name,
      value: item.id,
      className: item.category === DESIGN_FAILED ? 'aurora-debug-select-failed' : undefined,
    }))
}
/**
 * use only Andes
 */
class DebugMenu extends PureComponent {

  selectClick = (e) => {
    e && e.stopPropagation();
  }

  getSelect = ({
    disabled,
    selectItem,
    selectFn,
    className,
    options = [],
    product,
    menuType
  }) => {
    return <span onClick={(e) => this.selectClick(e)}>
      <Select
        disabled={disabled}
        value={selectItem ? selectItem.id : ""}
        onChange={(value) => selectFn(value)}
        className={`aurora-select aurora-debug-select ${className}`}
        classNames={{ popup: { root: 'aurora-debug-select-down-drop' } }}
        popupMatchSelectWidth={false}
        getPopupContainer={() => document.getElementById('root')}
        defaultActiveFirstOption={false}
        options={getOptions(options, product, menuType)}
      />
    </span>
  }

  getLabelRender = (item, menuType, product) => {
    const selected = menuType === item.key && item.key !== NETWORK_PARAMETER;
    return <div className={menuType === item.key ? 'aurora-debug-menu-item-selected' : "aurora-debug-menu-item"}>
      <span className='debug-menu-item-span'>{item.title}</span>
      {selected ? this.getSelect({
        selectItem: item.info.selectInfo,
        selectFn: (value) => this.props.changeSelectInfo(value, item.key),
        className: "aurora-debug-select-simulation-width",
        options: item.info.selectList || [],
        menuType,
        product
      }) : null}
      {selected && [PCB_CHANNEL, EXPERIMENTS].includes(item.key) ? this.getSelect({
        selectItem: item.info.selectChild,
        selectFn: (value) => this.props.changeSelectChild(value, item.key),
        className: "aurora-debug-select-simulation-width",
        options: item.info.selectChildren || [],
        product
      }) : null}
      {selected && item.key === EXPERIMENTS ? this.getSelect({
        selectItem: item.info.selectSweep,
        selectFn: (value) => this.props.changeSelectSweep(value, item.key),
        className: "aurora-debug-select-simulation-width",
        options: item.info.selectSweeps || [],
        product
      }) : null}
    </div>
  }

  render() {
    const { menuType, debugMenuList, product, channelId } = this.props;
    const _debugMenuList = !channelId ? debugMenuList.filter(item => item.key !== NETWORK_PARAMETER) : debugMenuList;
    return <div className='aurora-debug-menu'>
      <Tabs
        activeKey={-1}
        tabPosition="top"
        onChange={(key) => this.props.changeDebugItem(null, key)}
        items={_debugMenuList.map(item => {
          return {
            label: this.getLabelRender(item, menuType, product),
            key: item.key,
          };
        })}
        onFocusCapture={(e) => {
          e.preventDefault();
          e.stopPropagation();
          e.currentTarget.blur();
        }}
      />
    </div>
  }
}

export default DebugMenu;
export { NETWORK_PARAMETER };